

export const stripLeadingZeroes = (number: string): string => {
    if (number[0] === '0') {
        return stripLeadingZeroes(number.slice(1, number.length));
    }
    return number;
};
